import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import View from '@bubble-ui/primitive-view';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { platformSelect } from '@bubble-ui/util-platform';
import { defaultDesignTokens } from './defaultDesignTokens';

/**
 * Frames can be stacked to display multiple frames as a list of elements that belongs to the same type.
 * @talebook https://bubble-ui.klarna.net/#components/frame-stack
 */
var FrameStack = _ref => {
  var {
    backgroundColorToken = 'frame-stack/background-color',
    backgroundColorTokenArgs,
    cornerRadiusToken = 'frame-stack/corner-radius',
    children,
    id,
    paddingToken = 'frame-stack/padding',
    testID,
    UNSAFE_props
  } = _ref;
  var filteredChildren = React.Children.toArray(children).filter(Boolean);
  var designContext = useDesignContext(defaultDesignTokens);
  var separatorHeight = designContext.get('frame-stack/separator-height').value();
  var separatorColor = designContext.get('frame-stack/separator-color').toString();
  var separatorAfterLast = designContext.get('frame-stack/separator-after-last');
  var outerCornerRadius = designContext.get(cornerRadiusToken, {
    position: 'default'
  }).value();
  var innerCornerRadius = designContext.get('frame-stack/corner-radius', {
    position: 'inner'
  }).value();
  return /*#__PURE__*/React.createElement(View, _extends({}, platformSelect({
    native: {
      testID
    },
    default: {
      id
    }
  }), UNSAFE_props), /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, filteredChildren.map((child, i) => {
    var _child$props;
    var borderTopRadius = i === 0 ? outerCornerRadius : innerCornerRadius;
    var borderBottomRadius = i === filteredChildren.length - 1 ? outerCornerRadius : innerCornerRadius;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
      backgroundColorToken: child.props.backgroundColorToken || backgroundColorToken,
      backgroundColorTokenArgs: child.props.backgroundColorTokenArgs || backgroundColorTokenArgs,
      paddingToken: child.props.paddingToken || paddingToken,
      UNSAFE_style: _objectSpread(_objectSpread({}, (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.UNSAFE_style), {}, {
        borderRadius: undefined,
        borderTopLeftRadius: borderTopRadius,
        borderTopRightRadius: borderTopRadius,
        borderBottomRightRadius: borderBottomRadius,
        borderBottomLeftRadius: borderBottomRadius
      })
    }), (separatorAfterLast || i < filteredChildren.length - 1) && /*#__PURE__*/React.createElement(View, {
      style: {
        height: separatorHeight,
        backgroundColor: separatorColor
      }
    }));
  })));
};
FrameStack.displayName = 'FrameStack';
export default FrameStack;
//# sourceMappingURL=index.js.map